import { Flex } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { RedirectToAppButton } from '@/widgets/RedirectToAppButton';
import { usePageName } from '@/shared/hooks';
import DesktopMenu from './DesktopMenu';

const DesktopDefaultHeader = () => {
  const { t } = useTranslation();
  const pageName = usePageName();

  return (
    <Flex
      alignItems='center'
      justifyContent={{ base: 'end', lg: 'space-between' }}
      w={{ base: 'fit-content', lg: 'full' }}
    >
      <DesktopMenu />

      <Flex gap='md'>
        <RedirectToAppButton
          buttonText={t('common.header.login')}
          dataLayer={{ data: { redirected_from: `${pageName}_header` } }}
          display={{ base: 'none', md: 'flex' }}
          pageName='login'
          variant='link'
        />
        <RedirectToAppButton
          buttonText={t('common.header.startFreeTrial')}
          dataLayer={{ data: { redirected_from: `${pageName}_header` } }}
          pageName='signup'
          variant={{ base: 'link', md: 'solid' }}
        />
      </Flex>
    </Flex>
  );
};

export default DesktopDefaultHeader;
